import styled from 'styled-components';

// Mesmo chrome do ChartHistogram (header + wrapper) — tokens do tema
// legado (colors.*) pra ficar consistente com os outros charts do modal.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const Title = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.darkerblue};
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
`;

export const SubTitle = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.label};
`;

export const InfoLine = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 14px;
`;

export const InfoItem = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.colors.label};
  font-variant-numeric: tabular-nums;

  strong {
    color: ${(props) => props.theme.colors.darkerblue};
    font-weight: 700;
  }
`;

export const ChartWrapper = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${(props) => props.theme.colors.label};
  font-size: 13px;
`;
